"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LotteryEventType = void 0;
var LotteryEventType;
(function (LotteryEventType) {
    LotteryEventType["RoundFinalized"] = "RoundFinalized";
    LotteryEventType["RoundStarted"] = "RoundStarted";
    LotteryEventType["RoundEnded"] = "RoundEnded";
    LotteryEventType["Released"] = "Released";
    LotteryEventType["Prize"] = "Prize";
})(LotteryEventType || (exports.LotteryEventType = LotteryEventType = {}));
//# sourceMappingURL=lottery.js.map